import type { OfficeLocationLink } from '@jlg-website/database/types';
import type { SubmenuItem, SubmenuSection } from './type';

export function groupLocationsByCountry(locations: OfficeLocationLink[]): SubmenuSection[] {
  const order: string[] = [];
  const byCountry = new Map<string, SubmenuItem[]>();

  for (const { city, slug, country } of locations) {
    if (!byCountry.has(country)) {
      byCountry.set(country, []);
      order.push(country);
    }
    byCountry.get(country)!.push({ label: city, url: slug });
  }

  return order.map((country) => ({
    title: country,
    items: byCountry.get(country)!,
  }));
}
